module.exports = __webpack_public_path__ + "static/media/svg-1.715313cd.svg";